import React from "react";
import { withRouter } from 'react-router-dom';
import { baseUrl, partyBrands } from '../../common/config.js';

import { domain } from '../../common/config.js';
import { apiService } from '../../common/apiCallService';
import { saveActivity } from '../../common/commonService';
import './AnalysingHands.css';
import medals from './medals.json';
// const baseUrlImg = "https://mygame-dev.mypartypokerlive.com";
let medalPath = "/images/Medals/notEnoughHands/tournament.png";
const medal_lists = "/images/pokerwhiz/medal_lists.png";
const medal_lists_tablets = "/images/pokerwhiz/medal_lists_tablet.png";
const session_report_icon = "/images/pokerwhiz/session_report_icon.jpg";
const queryString = require('query-string');
import Media from 'react-media';
import {
  PlayerLevel
} from "mygame-components";
import { getColor, getTextColor, getHoverColor, getDarkTextColor, getImage } from "../../common/ThemeService.js";
class AnalysingHands extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      starList: [],
      medalList: [],
      loading: false,
      openSkillLevel: false,
      summaryInfo: {},
      loggedInType: localStorage.getItem('loggedInType')
    }
  }

  componentDidMount() {
    this.getMedal();
  }

  getMedal = () => {
    let reqBody = {
      gameType: this.props.gameType === "plo" ? "PLO" : this.props.gameType,
      ringType: this.props.ringType,
      dateRange: this.props.dateRange,
      accountName: localStorage.getItem("accountName")
    }
    reqBody.accountName = localStorage.getItem("accountName");
    apiService(`${baseUrl}/reportCard/getLandingPageSkillLevel`, reqBody, async (data) => {
      this.setState({ summaryInfo: data[0] })
    }, (err) => {
      this.setState({ loading: false })
      console.log("error", err)
    })
  }



  getSkillLevel = (gameType) => {
    let track = {}
    track.hit_page = 'HomePage';
    track.hit_type = 'LearnSkillLevels';
    track.hit_attribute1 = this.props.gameType;
    saveActivity(track);
    this.setState({ loading: true })
    apiService(`${baseUrl}/summaryInfo/list`, { gameType: gameType }, async (data) => {
      apiService(`${baseUrl}/star/list`, { gameType: gameType }, async (data1) => {
        let starListElem = []
        data1.map((starObj, i) => {
          starListElem.push(<div className="exp-level-div">
                <span className="exp-level-span" key={"key" + i}>
                {`Hands: ${starObj.min_hand} ${starObj.max_hand ? `- ${starObj.max_hand}` : ''}`}</span>
                <img className="expStars" key={i}
                style={{ height: 30,width:130 ,marginLeft: "-5px"}}
                src={`${getImage("/images/Stars/",`/Star_${starObj.star}.png`)}`}
            /></div>);
        })
        this.setState({ starList: starListElem, medalList: data, loading: false, openSkillLevel: true })
      }, (err) => {
        this.setState({ loading: false })
        console.log("error", err)
      })
    }, (err) => {
      this.setState({ loading: false })
      console.log("error", err)
    })
  }

  getPercentageToNextLevel = (current, points) => {
    let min = current.min_range
    let max = current.max_range
    let result = ""
    if (current.medal == "Rookie") {
      result = ((parseFloat(points) / parseFloat(max)) * 100).toFixed(2)
    } else {
      result = ((parseFloat(points) - parseFloat(min)) * 10).toFixed(2)
    }
    return result;
  }

  openReport = () =>{
    let track = {}
    track.hit_page = 'HomePage';
    track.hit_type = 'LaunchReportCard';
    track.hit_attribute1 = this.props.gameType;
    saveActivity(track);
    this.props.history.push(`/ReportCard/${localStorage.getItem('accountName')}/${this.props.gameType}?${queryString.stringify({
      hitLevel: 'All Level',
      hitRange: this.props.dateRange,
      hitType: this.props.ringType
    })}`)
  }

  render() {
    medalPath = "/images/Medals/"+ (partyBrands.includes(this.state.loggedInType)?'PartyPoker/notEnoughHands':'notEnoughHands') +"/tournament.png";
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const themeDarkTextColor = getDarkTextColor()
    const themeHoverColor = getHoverColor()
    let nextMedal = null;
    let currentMedal = null;
    let gameName =  ""
    if(this.props.gameType){
      if(this.props.gameType === "cash"){
        gameName = "NLH Cash Game"
      }else if(this.props.gameType === "plo"){
        gameName = "PLO Cash Game"
      } else if(this.props.gameType === "tournament"){
        gameName = "Tournament"
      }else{
        gameName = "Spin"
      }
    }
    let nextLevelPercentage = 0
    let medalFlag = false;
    let medalsList = []
    let hands = 0
    let skillLevel = ""
    if (this.props.summaryInfo) {
      hands = this.props.summaryInfo.hands
      if (this.props.summaryInfo.medal) {
        medals.map((medal) => {
          if (medalFlag) {
            medalsList.push(medal);
          }
          if (this.props.summaryInfo.medal === medal.medal) {
            medalsList.push(medal)
            medalFlag = true
          }
        })
        if (medalsList.length > 0) {
          nextLevelPercentage = this.getPercentageToNextLevel(medalsList[0], this.props.summaryInfo.points)
          skillLevel = medalsList[0].medal
        }
        currentMedal = medalsList.length > 0 ? 
          '/images/Medals/' + (partyBrands.includes(this.state.loggedInType) ? 'PartyPoker' + '/' + this.props.gameType : this.props.gameType) + '/' + medalsList[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + medalsList[0].medal.replace(/[^A-Z0-9-]/ig, "") + '_0.png'
        : null;
        nextMedal = medalsList.length > 1 ? 
        '/images/Medals/' + (partyBrands.includes(this.state.loggedInType) ? 'PartyPoker' + '/' + this.props.gameType : this.props.gameType) + '/' + medalsList[1].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + medalsList[1].medal.replace(/[^A-Z0-9-]/ig, "") + '_0.png'
        : null;
      } else {
        nextMedal = '/images/Medals/' + (partyBrands.includes(this.state.loggedInType) ? 'PartyPoker' + '/' + this.props.gameType : this.props.gameType)  + '/' + medals[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + medals[0].medal.replace(/[^A-Z0-9-]/ig, "") + '_0.png'
      }
       
    }
    const showModal = this.state.openSkillLevel ? 'displayBlock' : 'displayNone'
    return (
      <div>
        <style>
          {`.learnAboutButton:hover {\
              background-color: ${themeHoverColor} 
          `}
        </style>
       {hands < 100 &&  <div className="mg_ss_header_not_report">
          <div className="mg_ss_header_div mg_ss_header_not_report_content">
            <div className="analysing-your-nlh-c">Analysing your {gameName} hands...</div>
          </div>
          <div>
          <Media query="(min-width: 768px) and (max-width: 1024px)">
          {matches =>
            matches ? <img
            src={"/images/LandingPage/skill_level_group/tablet/"+this.props.gameType+".png"}
            alt=""
            srcSet=""
            className="mg_ss_header_not_report_medal"
          /> : <img
          src={ "/images/LandingPage/skill_level_group/desktop/"+this.props.gameType+".png"}
          alt=""
          srcSet=""
          className="mg_ss_header_not_report_medal"
        />
          }
        </Media>
          {/* <Media queries={{
          small: "(max-width: 767px)",
          medium: "(min-width: 768px) and (max-width: 1024px)",
          large: "(min-width: 999px)"
        }}>
          {matches => (
            <div>
              {matches.small && <img
              src={baseUrlImg + medal_lists}
              alt=""
              srcSet=""
              className="mg_ss_header_not_report_medal"
            />}
              {matches.medium && <img
              src={baseUrlImg + medal_lists_tablets}
              alt=""
              srcSet=""
              className="mg_ss_header_not_report_medal"
            />}
              {matches.large && <img
              src={baseUrlImg + medal_lists}
              alt=""
              srcSet=""
              className="mg_ss_header_not_report_medal"
            />}
            </div>
          )}
        </Media> */}
            
          </div>
        </div>}
      
      <div className="analyse_top_div">
        {this.state.medalList && this.state.starList && <PlayerLevel
                    domain={domain}
                    showModal={showModal}
                    medalsDetails={this.state.medalList}
                    starListElem={this.state.starList}
                    closeLevelInfo={() => { this.setState({ openSkillLevel: false }) }}
                />}
        {hands >= 100 &&  
        <div className="report_medal_div">
          <div>
            <img
                src={ (currentMedal ? currentMedal : medalPath)}
              alt=""
              srcSet=""
              className="mg_ss_header_medal"
            />
          </div>
          <div className="mg_ss_header_text">
            <div className="mg_text_bold">
              {gameName} Report
            </div>
            <div className="margin-top-5">
              Skill Level: {skillLevel}
            </div>
          </div>
        </div> 
        
         } 
        <div className={parseInt(hands) >= 100 ? "margin-top-10" : "margin-top-30"}>
          {parseInt(hands) >= 100 ? 
          <div className="mg_ss_header_div">
            <div className="mg_ss_progress_level_text">
              Progress to level up!
        </div>
            <div className="mg_ss_margingLeft_auto">
              <img
                  src={ (nextMedal ? nextMedal : medalPath)}
                alt=""
                srcSet=""
                className="mg_ss_progress_medal"
              />
            </div>
          </div>
           :  
          <div className="mg_ss_header_div">
            <div className="play-46-more-hands-f">
              Play {100 - parseInt(hands)} more hands for your report card
      </div>
          </div>
           } 
          <div className="mg_progress_outer_div margin-top-10">
            <div className="mg_progress_middle_div">
              {parseInt(hands) < 100 ? 
              <div className="mg_progress_inner_div"
                style={{width:parseInt(hands)+"%"}}
              />
              :
              <div className="mg_progress_inner_div"
                style={{width:parseInt(nextLevelPercentage)+"%"}}
              />
               } 
            </div>
          </div>
        </div>
        <Media query="(max-width: 767px)">
          {matches => matches ? 
          <div className="margin-top-10">
          {parseInt(hands) >= 100 ?
          <div>
            <div className="mg_ss_header_div">
              <div>
                <img className="ml-3 mr-3 mg_ss_left_avtar" src={`//${domain}${session_report_icon}`} />
              </div>
              <div className="ml-2 mg_ss_avtar_report_text">
                Check out your personal report card for in depth game analysis.
          </div>
            </div>
                    <div>
                      <button className='reportCardButton' onClick={() => this.openReport()} data-e2e="Open Report Card"
                        style={{
                          backgroundColor: themeColor,
                          color: themeTextColor,
                          borderColor: themeColor,
                        }}
                      >
                      Open Report Card
                      </button>
                    </div>
        <div className="margin-top-10"><button className='learnAboutButton' onClick={() => this.getSkillLevel(this.props.gameType)} data-e2e="Learn about skill levels"
          style={{
            color: themeDarkTextColor,
            borderColor: themeColor,
          }}        
        >
            Learn about skill levels
      </button></div>
          </div> :
          <div className="margin-top-30">
          <button className='learnAboutButton' onClick={() => this.getSkillLevel(this.props.gameType)} data-e2e="Learn about skill levels"
            style={{
              color: themeDarkTextColor,
              borderColor: themeColor,
            }}  
          >
            Learn about skill levels
      </button>
        </div>
           } 
          
        </div>
           : 
           <div className="margin-top-10">
          {parseInt(hands) >= 100 ?
          <div>
            <div className="mg_ss_header_div">
              <div>
                <img className="ml-3 mr-3 mg_ss_left_avtar" src={`//${domain}${session_report_icon}`} />
              </div>
              <div className="ml-2 mg_ss_avtar_report_text">
                Check out your personal report card for in depth game analysis.
          </div>
            </div>
            <div className="analyse-displey-flex">
                      <div>
                        <button className='reportCardButton' onClick={() => this.openReport()} data-e2e="Open Report Card"
                          style={{
                            backgroundColor: themeColor,
                            color: themeTextColor,
                            borderColor: themeColor,
                          }}
                        >
                          Open Report Card
                        </button>
                      </div>
        <div className="margin-left-15"><button className='learnAboutButton' onClick={() => this.getSkillLevel(this.props.gameType)}
          style={{
            color: themeDarkTextColor,
            borderColor: themeColor,
          }}  
        >
            Learn about skill levels
      </button></div>
            </div>
          </div> :
          <div className="margin-top-30">
          <button className='learnAboutButton' onClick={() => this.getSkillLevel(this.props.gameType)} data-e2e="learn about skill levels"
            style={{
              color: themeDarkTextColor,
              borderColor: themeColor,
            }}  
          >
            Learn about skill levels
      </button>
        </div>
           } 
          
        </div> }
        </Media>       
        
      </div>
      </div>
    )
  }

}

export default withRouter(AnalysingHands);


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/AnalysingHands.js
 **/